import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { propIn } from '../../common/utils/immutableHelper';
import { Capacitor } from '@capacitor/core';
import { CAPACITOR_MN_KEYBOARD_PLUGIN } from '../../capacitor_plugins/pluginConstants';
import globalLogger from '../logger';
import { isNotImplementedError } from '../../capacitor_plugins/pluginErrorUtils';

const logger = globalLogger.createChannel('mobile.nativeThemeManager');

const selectAppTheme = propIn(['app', 'theme', 'theme']);

const milanoteToCapacitorTheme: Record<string, string> = {
    ['light-theme']: 'LIGHT',
    ['dark-theme']: 'DARK',
};

const setKeyboardTheme = async (theme: string) => {
    if (!Capacitor.isPluginAvailable(CAPACITOR_MN_KEYBOARD_PLUGIN)) return;
    const { KeyboardPlugin } = await import('../../capacitor_plugins/keyboard'); // can't import this on web or it'll throw an error

    // Type is actually Keyboard.KeyboardStyle but TS can't handle dynamic imports
    try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        await KeyboardPlugin.setStyle({ style: theme as any });
    } catch (error) {
        if (isNotImplementedError(error)) {
            return;
        }
        logger.error('Failed to set keyboard theme', error);
    }
};

const setStatusBarTheme = async (theme: string) => {
    if (!Capacitor.isPluginAvailable('StatusBar')) return;
    const { StatusBar } = await import('@capacitor/status-bar'); // can't import this on web or it'll throw an error

    // Like above -- this one is of type StatusBar.Style
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    StatusBar.setStyle({ style: theme as any });
};

const useNativeThemeManager = () => {
    const theme = useSelector(selectAppTheme);
    useEffect(() => {
        const capacitorTheme = milanoteToCapacitorTheme[theme];

        setKeyboardTheme(capacitorTheme);
        setStatusBarTheme(capacitorTheme);
    }, [theme]);
};

export default useNativeThemeManager;
